import { render, staticRenderFns } from "./SlidingBannerUpdateSlide.vue?vue&type=template&id=2e8ccfe0"
import script from "./SlidingBannerUpdateSlide.vue?vue&type=script&lang=ts"
export * from "./SlidingBannerUpdateSlide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports